"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearExecution = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var preparedExecution_1 = require("./preparedExecution");
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var preparedExecutionByRef_1 = require("./preparedExecutionByRef");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var BearExecution = /** @class */ (function (_super) {
    tslib_1.__extends(BearExecution, _super);
    function BearExecution(authCall, workspace) {
        var _this = _super.call(this, workspace) || this;
        _this.authCall = authCall;
        return _this;
    }
    BearExecution.prototype.forDefinition = function (def) {
        return new preparedExecution_1.BearPreparedExecution(this.authCall, def, this);
    };
    BearExecution.prototype.forInsightByRef = function (insight, filters) {
        var def = sdk_model_1.defWithDimensions(sdk_model_1.newDefForInsight(this.workspace, insight, filters), sdk_model_1.defaultDimensionsGenerator);
        var nonNullFilters = compact_1.default(filters);
        /*
         * Need different factory to retain `insight` and `filters` during as the prepared execution is
         * cumulatively constructed
         */
        var byRefFactory = new BearExecutionByRef(this.authCall, this.workspace, insight, nonNullFilters);
        return new preparedExecutionByRef_1.BearPreparedExecutionByRef(this.authCall, def, insight, nonNullFilters, byRefFactory);
    };
    return BearExecution;
}(sdk_backend_base_1.AbstractExecutionFactory));
exports.BearExecution = BearExecution;
/**
 * Execution by reference is a different execution type, represented by different class using with different endpoint. Yet
 * it still has to stick to the cumulative and fluent API specified by IPreparedExecution. On top of that, the executions
 * need to be done in a way that they support 'decorability' - so that they can be transparenty wrapped by for instance
 * caching decorator.
 *
 * The transparent decorability in combination with the requirements for cumulative, immutable construction require
 * that each implementation of prepared execution receives an execution factory to create the new instance of
 * the prepared execution with updated definition.
 *
 * In order for this to work with the execution by reference (implemented by different class, requiring always
 * the entire insight which contains the necessary 'ref'), it is essential to use this other execution factory which
 * retains this essential detail during the cumulative operations.
 */
var BearExecutionByRef = /** @class */ (function (_super) {
    tslib_1.__extends(BearExecutionByRef, _super);
    function BearExecutionByRef(authCall, workspace, insight, filters) {
        if (filters === void 0) { filters = []; }
        var _this = _super.call(this, workspace) || this;
        _this.authCall = authCall;
        _this.insight = insight;
        _this.filters = filters;
        return _this;
    }
    BearExecutionByRef.prototype.forDefinition = function (def) {
        return new preparedExecutionByRef_1.BearPreparedExecutionByRef(this.authCall, def, this.insight, this.filters, this);
    };
    BearExecutionByRef.prototype.forInsightByRef = function (insight, filters) {
        var def = sdk_model_1.defWithDimensions(sdk_model_1.newDefForInsight(this.workspace, insight, filters), sdk_model_1.defaultDimensionsGenerator);
        return new preparedExecutionByRef_1.BearPreparedExecutionByRef(this.authCall, def, insight, filters, this);
    };
    return BearExecutionByRef;
}(sdk_backend_base_1.AbstractExecutionFactory));
//# sourceMappingURL=executionFactory.js.map